module.exports = __webpack_public_path__ + "media/Afterwar (X'mass).10c06731.mp3";